import UsersSettingsProvider from "context/admin/users-settings";
import UsersSettings from "page_components/admin/users/Settings";

const Settings = () => (
  <UsersSettingsProvider>
    <UsersSettings />
  </UsersSettingsProvider>
);

export default Settings;
